import React, { useState } from "react";
import { Link } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoMdCloseCircle } from "react-icons/io";
import "./navbar.css";
import "./nav_mobile.css";
import { navLinks } from "./navLinks";

export default function Navbar() {
  // Toggle dropdown visibility
  const [activeDropdown, setActiveDropdown] = useState(null);
  const toggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  // hamburger menu
  const [showMenu, setShowMenu] = useState(null);
  const toggleMobileDropdown = (key) => {
    setShowMenu(showMenu === key ? null : key);
  };

  const toggleMobileMenu = () => {
    setShowMenu((prev) => !prev);
  };

  return (
    <div className="navbar">
      <nav className="menu-web">
        <ul className="nav-links">
          {navLinks.map((item) => (
            <li
              key={item.key}
              className={`nav-item ${item.columns ? "dropdown" : ""}`}
              onMouseEnter={() => item.columns && toggleDropdown(item.key)}
              onMouseLeave={() => toggleDropdown(null)}
            >
              {/* IF NO DROPDOWN → SIMPLE LINK */}
              {!item.columns && (
                <Link to={item.to} className="nav-link">
                  {item.title}
                </Link>
              )}

              {/* IF DROPDOWN EXISTS */}
              {item.columns && (
                <>
                  <span className="dropdown-toggle">{item.title}</span>

                  <div
                    className={`dropdown-menu ${
                      activeDropdown === item.key ? "show" : ""
                    }`}
                  >
                    <div className="dropdown-content">
                      {/* LEFT IMAGE */}
                      {item.leftImage && (
                        <div className="dropdown-left">
                          <img src={item.leftImage} alt={item.title} />
                        </div>
                      )}
                      <div className="dropdown-columns">
                        {item.columns.map((column, colIndex) => (
                          <React.Fragment key={colIndex}>
                            {/* COLUMN */}
                            <ul className="dropdown-column">
                              {column.map((link, index) => (
                                <li key={index}>
                                  <Link to={link.to}>{link.name}</Link>
                                </li>
                              ))}
                            </ul>

                            {/* DIVIDER: show only if NOT the last column */}
                            {colIndex !== item.columns.length - 1 && (
                              <div className="divider"></div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>

                      {/* RIGHT TEXT */}
                      {item.rightText && (
                        <div className="dropdown-right">
                          <p>{item.rightText}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </nav>

      {/* ----------------------- MOBILE MENU ----------------------- */}
      <nav className={`menu-mobile ${showMenu ? "active" : ""}`}>
        {/* top bar */}
        <div className="menu-logos">
          <img src="/assets/images/icons/mit_logo.webp" />
        </div>

        <ul className="nav-links-mobile">
          {navLinks.map((item) => (
            <li key={item.key} className="nav-item-mobile">
              {/* If item has no dropdown */}
              {!item.columns && (
                <Link
                  to={item.to}
                  onClick={() => setShowMenu(false)}
                  className="nav-link-mobile"
                >
                  {item.title}
                </Link>
              )}

              {/* If item has dropdown */}
              {item.columns && (
                <>
                  <div
                    className="dropdown-toggle-mobile"
                    onClick={() => toggleMobileDropdown(item.key)}
                  >
                    {item.title}
                  </div>

                  <div
                    className={`dropdown-menu-mobile ${
                      showMenu === item.key ? "open" : ""
                    }`}
                  >
                    <div className="dropdown-columns-mobile">
                      {item.columns.map((column, colIndex) => (
                        <ul className="dropdown-column-mobile" key={colIndex}>
                          {column.map((link, index) => (
                            <li key={index}>
                              <Link
                                to={link.to}
                                onClick={() => setShowMenu(false)}
                              >
                                {link.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>

        {/* bottom section */}
        <div className="menu-bottom-section">
          <h3>Quick Links</h3>

          <div className="menu-card">
            <h1 className="title">Admissions Open For Academic Year 2026-27</h1>
            <button className="button" id="menu-card-btn" to="/admissions">
              Apply Now
            </button>
          </div>
        </div>
      </nav>

      {/* hamburger menu */}
      <div className="ham-menu" onClick={toggleMobileMenu}>
        {showMenu ? (
          <IoMdCloseCircle style={{ color: "white ", fontSize: "22px" }} />
        ) : (
          <RxHamburgerMenu style={{ color: "white", fontSize: "22px" }} />
        )}
      </div>
    </div>
  );
}

/* for hide path just change to="/aboutus/about-manet" into to="/aboutus/kfhgjfghjfh/about-manet"  or to="/bgngngnn/aboutus/about-manet" etc 
         anything we can add here it will hide main route path , it will not affect the page routing
         remember update path into aboutrouts also */
